var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CockpitMatryoshkaItemOperations',{attrs:{"label-archive-id":_vm.labelArchiveId},on:{"operation-success":function($event){return _vm.$emit('operation-success', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }